import { render, staticRenderFns } from "./AddPrescriptionForm.vue?vue&type=template&id=26cae9ae&"
import script from "./AddPrescriptionForm.vue?vue&type=script&lang=js&"
export * from "./AddPrescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports